import React from 'react';
import {Box, Grid, Typography, Button, ButtonGroup, Card, CardContent } from '@mui/material';

const ManageOccupancy = ({ queueData, changeVisitors, loading}) => {
    const occupancyColor = queueData?.currentCapacity > queueData?.capacity ? 'red' : queueData?.currentCapacity === queueData?.capacity ? 'white' : 'lightGreen';

    return (
        <Grid container spacing={1}>
            <Grid item xs={3}>
                <Box sx={{display: 'flex'}}>
                    <Box>
                        <Typography variant="h6" gutterBottom>Occupancy</Typography>
                    </Box>
                    <Box>
                        <Button
                            sx={{height: '25px',
                                fontSize: '1em',
                                ml: '10px',
                                fontWeight: '600',
                                padding: '10px'}}
                            variant="contained"
                            color="error"
                            onClick={() => changeVisitors(-500)}
                            disabled={loading}>
                            Clear
                        </Button>
                    </Box>
                </Box>
                <Typography variant="h4" style={{ color: occupancyColor }} sx={{paddingBottom: '30px'}}>
                    {queueData?.currentCapacity} / {queueData?.capacity} max
                </Typography>

                <Typography variant="h6" gutterBottom>Total Visitors: {queueData.totalVisitors}</Typography>
            </Grid>
            <Grid item xs={9} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography variant="h6" gutterBottom>Add Visitors</Typography>
                    <Box aria-label="Add Visitors" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', flexWrap: 'wrap' }}>
                        {Array.from({ length: 10 }, (_, i) => (
                            <Button
                                sx={{height: '35px',
                                    marginInline: '10px',
                                    marginBlock: '7px',
                                    fontSize: '1em',
                                    fontWeight: '700',
                                    flexGrow: '1',
                                    minWidth: 'fit-content',
                                    padding: '2px'}}
                                variant="contained"
                                color="success"
                                key={i}
                                onClick={() => changeVisitors(10 - i)}
                                disabled={loading}
                            >
                                + {10 - i}
                            </Button>
                        ))}
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ManageOccupancy;
